// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { joyoKanjiMeanings } from "../../consts/joyoKanjiMeanings";
import { jinmeiyoKanjiMeanings } from "../../consts/jinmeiyoKanjiMeanings";
import { localizeKanjiMeaning } from "../../i18n/localizedKanji";
import { kanjiDetails } from "../../consts/kanjiDetails";

const MIN_PRACTICE_STAGE = 1; // Apprentice I
const MAX_PRACTICE_STAGE = 6; // Guru II
const SESSION_SIZE = 20;
const EXERCISE_TYPES = ["meaning", "reading", "stroke"];

const allKanjiMeanings = [...joyoKanjiMeanings, ...jinmeiyoKanjiMeanings];
const meaningBySymbol = new Map(allKanjiMeanings.map((entry) => [entry.symbol, entry.meaning]));

function shuffle(array) {
    const copy = [...array];
    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
}

function sampleExcluding(pool, exclude, count) {
    const candidates = shuffle(pool.filter((value) => value !== exclude));
    return candidates.slice(0, count);
}

export function buildQuizQueue(progressByKanji) {
    const dueSymbols = Object.entries(progressByKanji)
        .filter(
            ([symbol, progress]) =>
                progress.srsStage >= MIN_PRACTICE_STAGE &&
                progress.srsStage <= MAX_PRACTICE_STAGE &&
                kanjiDetails[symbol] &&
                meaningBySymbol.has(symbol)
        )
        .map(([symbol]) => symbol);

    return shuffle(dueSymbols)
        .slice(0, SESSION_SIZE)
        .map((symbol, index) => ({ symbol, type: EXERCISE_TYPES[index % EXERCISE_TYPES.length] }));
}

export function buildMeaningOptions(symbol, language = "en") {
    const correct = getMeaning(symbol, language);
    const pool = allKanjiMeanings
        .filter((entry) => entry.symbol !== symbol)
        .map((entry) => localizeKanjiMeaning(entry.symbol, entry.meaning, language));
    const distractors = sampleExcluding(pool, correct, 3);
    return shuffle([correct, ...distractors]);
}

let allReadingsCache = null;
function getAllReadings() {
    if (!allReadingsCache) {
        allReadingsCache = Object.values(kanjiDetails).flatMap((entry) => [...entry.onyomi, ...entry.kunyomi]);
    }
    return allReadingsCache;
}

export function buildReadingOptions(symbol) {
    const ownReadings = [...kanjiDetails[symbol].onyomi, ...kanjiDetails[symbol].kunyomi];
    const correct = ownReadings[Math.floor(Math.random() * ownReadings.length)];
    const distractors = sampleExcluding(getAllReadings(), correct, 3);
    return { correct, options: shuffle([correct, ...distractors]) };
}

export function getMeaning(symbol, language = "en") {
    const meaning = meaningBySymbol.get(symbol);
    return meaning ? localizeKanjiMeaning(symbol, meaning, language) : meaning;
}
